<template>
  <div>
    <div class="mb-3">
      <label for="" class="d-none d-lg-block">{{'Notes' | translate}}</label>
      <textarea class="form-control" rows="10" v-model="note.content"></textarea>
    </div>
    <button
      @click="submit"
      :class="{
          'btn': true,
          'btn-sm': true,
          'px-4': true,
          'btn-dark': !working && !error && !success,
          'btn-secondary': working && !error && !success,
          'btn-success': !working && !error && success,
          'btn-danger': !working && error && !success,
      }"
      :disabled="working || error || success"
    >
        <span v-if="!working && !error && !success">{{ 'Save' | translate }}</span>
        <span v-if="working && !error && !success"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> {{ 'Saving' | translate }}</span>
        <span v-if="!working && !error && success">{{ 'Saved' | translate }}</span>
    </button>
  </div>
</template>

<script>

export default {
  data() {
    return {
      working: false,
      success: false,
      error: false,
    }
  },
  methods: {
    handleErrors(error) {
      if (error.response && error.response.status === 401) {
        iziToast.info({
          title: this.$t('Log in'),
          message: this.$t('Log in to set progress'),
        })
      } else if (error.response && error.response.status === 419) {
        iziToast.info({
          title: this.$t('Log in'),
          message: this.$t('Session expired'),
        })
      } else {
        console.error(error)
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'bottomLeft',
        })
      }
    },
    reset() {
      this.working = false
      this.success = false
      this.error = false
    },
    async submit() {
      this.working = true
      try {
        const result = await this.$api.editNote(this.lecture.id, this.note.content)
        this.working = false
        this.success = true
      } catch (error) {
        this.error = true
        this.handleErrors(error)
      } finally {
        setTimeout(this.reset, 2000)
      }
    },
  },
  computed: {
    lecture() {
      return this.$store.state.currentLecture
    },
    note() {
      const note = _.head(this.lecture.notes)
      if (note) return note
      else
        return {
          content: null,
        }
    },
  },
}
</script>
